import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { first, map } from 'rxjs';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';
import { RoleEnum } from '@app/_api/enums/role.enum';
import { RolePermissionBuilder } from '@app/shared/permission/role-permission-builder';
import { EmployeeDataService } from '@app/core/services/employee-data.service';
import { EmployeeDto } from '@app/_api/dto';

export const adminSettingsGuard: CanActivateFn = (_route, _state) => {
  const adminSettingsRolePermission = RolePermissionBuilder.builder()
    .authorizeRole(RoleEnum.ADMIN)
    .authorizeRole(RoleEnum.PERSONAL)
    .authorizeRole(RoleEnum.REVIEWER);
  const employee$ = toObservable(inject(EmployeeDataService).employee).pipe(takeUntilDestroyed());
  return employee$.pipe(
    filter((e): e is EmployeeDto => !!e),
    first(),
    map(e => adminSettingsRolePermission.comparing(e.role).authorized),
  );
};
